import React from "react";

export default function SeasonSelect({ seasons, value, onChange }) {
  return (
    <div className="flex items-center gap-2 shrink-0">
      <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">
        Season
      </span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
      >
        {seasons.map((s) => (
          <option key={s.key} value={s.key}>
            {s.label}
          </option>
        ))}
      </select>
    </div>
  );
}
